<template>
  <div>
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Στοιχεία υπαλλήλου
      </h3>
      <div v-for="(card, index) in cards" :key="index">
        <div class="card">
            <div class="row">
                <div class="col-md-2">
                    <div class="mb-3">
                    <label class="mt-3">Ξένη Γλώσσα</label>
                    <multiselect
                        placeholder="Επιλογή Γλώσσας"
                        :options="trainingOptions"
                        v-model="card.selectedValue"
                        selectLabel="Eπιλογή Γλώσσας"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                        :max-height="150"
                    ></multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mt-3">
                    <label>Γνώση</label>
                    <multiselect
                        placeholder="Επιλογή Επιπέδου"
                        :options="gradeOptions"
                        v-model="card.gradeSelected"
                        selectLabel="Eπιλογή Επιπέδου"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                        :max-height="150"
                    ></multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mt-3">
                    <label>Περιγραφή</label>
                    <multiselect
                        placeholder="Επιλογή Επιπέδου"
                        :options="grade2Options"
                        v-model="card.grade2Selected"
                        selectLabel="Eπιλογή Επιπέδου"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                        :max-height="150"
                    ></multiselect>
                    </div>
                </div>
                <div class="col-md-1 mt-5">
                    <i
                        class="bx bx-plus-medical"
                        style="color:green;cursor:pointer;"
                        @click="addCard()"
                        >Προσθήκη
                    </i>
                </div>
                <div class="col-md-1 mt-5">
                    <i
                        class="bx bx-trash"
                        style="color:red;cursor:pointer;"
                        @click="removeCard(card.id)"
                        >Αφαίρεση
                    </i>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "Ergasiaka",
  components: {
    Multiselect,
  },

  data() {
    return {
      familyStatusSelected: "",

      familyStatusOptions: [
        "Ανύπαντρος/η",
        "Έγγαμος/η",
        "Διαζευγμένος/η",
        "Χήρος/α",
      ],
      trainingOptions: ["Αγγλικά", "Γερμανικά","Γαλλικά","Ιταλικά","Ισπανικά"],
      selectedValue: "",
      gradeOptions: ["Άριστη", "Πολύ Καλή", "Καλή"],
      gradeSelected: "",
      grade2Options: ["Proficiency", "Advanced","Lower"],
      grade2Selected: "",
      mkRangeOptions: [
        ...Array(19)
          .fill(1)
          .map((x, y) => x + y),
      ],
      mkSelected: "",
      cards: [
        {
            id: 1,
            selectedValue: "",
            gradeSelected: "",
            grade2Selected: "",
        }
        ],
    };
  },
  methods: {
    addCard() {
        this.cards.push({
        id: this.cards.length + 1,
        selectedValue: "",
        gradeSelected: "",
        grade2Selected: "",
        });
    },
    removeCard(id) {
        const index = this.cards.findIndex(card => card.id === id);
        if (index > -1) {
            this.cards.splice(index, 1);
        }
        if (Object(this.cards).length == 0) {
          this.addCard()
        }
    }
  }
};
</script>
